//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/logo.png";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import ThriveLogo from "assets/img/thrive-logo.png";
import IconButton from "@material-ui/core/IconButton";
import HSBanner from "assets/img/Banner-Image.png";


// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import LanguageSharpIcon from "@material-ui/icons/LanguageSharp";
import Grid from "@material-ui/core/Grid";
import { imageHandler } from "helpers/imageHandler";

export default function EnrollmentAdminConsentPending() {
  const { adminConsentPending,getAdminConsentStatus } = auth();
  const history = useHistory();
  const classes = consentStyles();
  const location = useLocation();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const [org, setOrg] = useState("");
  const [usLink, setusLink] = useState("");
  const [caLink, setcaLink] = useState("");
  const [frLink, setfrLink] = useState("");

  useEffect(() => {
    i18n.changeLanguage(param.get("lang"));
    let temp = param.get('org');
    if (temp == "ca") {
      setOrg("Henry Schein Canada")
    } else {
      setOrg("Henry Schein Dental")
    }
  }, []);

  useEffect(() => {
    handleGetAdminConsentStatus();
  }, []);

  const handleGetAdminConsentStatus = async () => {
    try {
      // setLoading(true);
      let res = await getAdminConsentStatus(token);
      if (res && res?.type == "success") {
       
        setusLink(res?.usLink)
        setcaLink(res?.caLink)
        setfrLink(res.frLink)
      
        return;
      }
     
    } catch (e) {
      console.log({ e });
    }
  };


  const handleGetData = async () => {
    try {
      let res = await adminConsentPending({ token });
      if (res?.type == "success") {
        window.location.replace(res?.referrerUrl);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  function handleRedirect() {
    if (org == "Henry Schein Canada") {
      window.open('https://www.henryschein.ca')
    } else {
      window.open('https://www.henryschein.com')
    }
  }

  return (
    <div className={classes.mainDiv}>
      <div className={classes.gridContainer}>
        <div className={classes.logoImgDiv}>
        <img
  src={
    org === "Henry Schein Dental"
      ? imageHandler?.[org]?.[i18n?.language]?.["Newheader"]
      : imageHandler?.[org]?.[i18n?.language]?.["nullHeaderLogo"]
  }
  className={classes.logoImg}
/>
        </div>
        <div className={classes.flexBoxDiv}>
          <Grid item className={classes.backToGrid}>
            <IconButton
              className={classes.globeIconBtn}
              onClick={handleRedirect}
            >
              <LanguageSharpIcon className={classes.languageIcon} />
            </IconButton>
            <br />
            <div
              className={classes.backtoHendry}
              onClick={handleRedirect}
            >
              {t(org)}
            </div>
          </Grid>
        </div>
      </div>
      <div className={classes.HSBanner}>
        <img src={imageHandler?.[org]?.[param.get("lang")]?.banner} alt="" width="100%" height="" />
      </div>

      <div className={classes.mainDiv}>
        <Card className={classes.card}>
          <div className={classes.divText}>{t("Activate Your Account")}</div>
          <div className={classes.divSubText}>
            {t("Thank you for enrolling")}.
            {t("Thrive Rewards is a no-fee discount program intended for private dental practice and small group practices")}.{" "}
            {org == "Henry Schein Dental" ?
              t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-888-6684") :
              t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-668-5558")}.{" "}
            {t("By enrolling in Thrive Rewards, you have read, understood and agree to the")}{" "}
            {org == "Henry Schein Dental" ? <a
              target="_blank"
              href={usLink}            >
              {t("[Terms & Conditions]")}
            </a> : param?.get("lang") == "fr" ? <a
              target="_blank"
              href={frLink}
            >
              {t("[Terms & Conditions]")}
            </a> : <a
              target="_blank"
              href={caLink}
            >
              {t("[Terms & Conditions]")}
            </a>}{" "}
            {t("of this program")}.
            {token && (
              <div className={classes.consentBtnDiv}>
                <Button
                  className={classes.consentBtn}
                  onClick={() => {
                    history.push(`/enrollment-admin-consent?token=${token}&lang=${param.get("lang")}`, {
                      login: true,
                    });
                  }}
                >
                  {t("Click to Activate")}
                </Button>
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
